import http from './http';

export default {
  all() {
    return http().get(`/v1/appointments`);
  },
  get(id) {
    return http().get(`/v1/appointments/${id}`);
  },
  create(data) {
    return http().post(`/v1/appointments`, data);
  },
  update(data) {
    return http().put(`/v1/appointments/${data.id}`, data);
  },
  cancel(data) {
    return http().put(`/v1/appointments/${data.id}/cancel`, data);
  },
}
